<template>
  <div
    class="nine-page flex-column justify-between align-center"
    :style="{ backgroundImage: `url(${getBrandImageUrl('nine/nine_bg.png')})` }"
  >
    <!-- <page-white-background title="初中中级体验词库" router-type="modal"> -->
    <ion-header class="ion-no-border">
      <div class="navbar flex-row align-center justify-between">
        <div class="navbar-item" style="display: inline-flex; align-items: center" @click="onClose">
          <img
            class="nav-icon cursor-pointer"
            :src="getBrandImageUrl('ai_smart_reading/nav_back.png?time=111')"
            alt=""
          />
          <span>返回</span>
          <!-- <img
            class="nav-icon cursor-pointer"
            src="@/assets/newNine/icon_back.png"
            alt=""
            @click="onClose"
          /> -->
        </div>
        <div class="navbar-item">单词速记</div>
        <div class="navbar-item navbar-item-right"></div>
      </div>
      <div class="info-box">
        <div
          class="word-option-box"
          :class="{ 'word-option-box--disabled': isStudent }"
          @click="showCourseSelect()"
        >
          <div v-if="courseName" class="course-name_text">
            {{ courseName }}
          </div>
          <div v-else class="course-name_empty">请选择要体验的词库</div>

          <img v-if="!isStudent" class="bottom-icon" src="@/assets/arrow_down.png" alt="" />
        </div>
      </div>
    </ion-header>
    <div class="flex-column align-center content-box">
      <div class="road-box">
        <div class="student-info">
          <div class="student-info-item">
            <div class="student-head">
              <img :src="studentAvatar" alt="" />
            </div>
            <div class="student-name">{{ studentName }}</div>
          </div>
        </div>
        <img class="road-img" :src="getBrandImageUrl('nine/nine_river.png')" alt="" />
        <div
          class="learn-word-box"
          :style="{ backgroundImage: `url(${getBrandImageUrl('nine/step0.png')})` }"
        >
          <div class="learn-word-text">{{ step0 || 0 }}</div>
          <div class="learn-word-text-bottom">待学单词</div>
        </div>
        <div
          class="step-size step1"
          :style="{
            backgroundImage: `url(${getBrandImageUrl('nine/step1.png')})`,
          }"
          @click="onMastery(step1, 1)"
        >
          <div
            class="step-bubble"
            :style="{ backgroundImage: `url(${getBrandImageUrl('nine/orange_bubble.png')})` }"
          >
            <div class="">{{ step1 || 0 }}</div>
          </div>
          <div class="step-label">易忘单词</div>
        </div>
        <div
          class="step-size step2"
          :style="{
            backgroundImage: `url(${getBrandImageUrl('nine/step2.png')})`,
          }"
          @click="onMastery(step2, 2)"
        >
          <div
            class="step-bubble"
            :style="{ backgroundImage: `url(${getBrandImageUrl('nine/gray_bubble.png')})` }"
          >
            <div class="">{{ step2 || 0 }}</div>
          </div>
          <div class="step-label">第一次复习</div>
        </div>
        <div
          class="step-size step3"
          :style="{
            backgroundImage: `url(${getBrandImageUrl('nine/step3.png')})`,
          }"
          @click="onMastery(step3, 3)"
        >
          <div
            class="step-bubble"
            :style="{ backgroundImage: `url(${getBrandImageUrl('nine/gray_bubble.png')})` }"
          >
            <div class="">{{ step3 || 0 }}</div>
          </div>
          <div class="step-label">第二次复习</div>
        </div>
        <div
          class="step-size step4"
          :style="{
            backgroundImage: `url(${getBrandImageUrl('nine/step4.png')})`,
          }"
          @click="onMastery(step4, 4)"
        >
          <div
            class="step-bubble"
            :style="{ backgroundImage: `url(${getBrandImageUrl('nine/gray_bubble.png')})` }"
          >
            <div class="">{{ step4 || 0 }}</div>
          </div>
          <div class="step-label">第三次复习</div>
        </div>
        <div
          class="step-size step5"
          :style="{
            backgroundImage: `url(${getBrandImageUrl('nine/step5.png')})`,
          }"
          @click="onMastery(step5, 5)"
        >
          <div
            class="step-bubble"
            :style="{ backgroundImage: `url(${getBrandImageUrl('nine/gray_bubble.png')})` }"
          >
            <div class="">{{ step5 || 0 }}</div>
          </div>
          <div class="step-label">第四次复习</div>
        </div>
        <div
          class="step-size step6"
          :style="{
            backgroundImage: `url(${getBrandImageUrl('nine/step6.png')})`,
          }"
          @click="onMastery(step6, 6)"
        >
          <div
            class="step-bubble"
            :style="{ backgroundImage: `url(${getBrandImageUrl('nine/gray_bubble.png')})` }"
          >
            <div class="">{{ step6 || 0 }}</div>
          </div>
          <div class="step-label">第五次复习</div>
        </div>
        <div
          class="step-size step7"
          :style="{
            backgroundImage: `url(${getBrandImageUrl('nine/step7.png')})`,
          }"
          @click="onMastery(step7, 7)"
        >
          <div
            class="step-bubble"
            :style="{ backgroundImage: `url(${getBrandImageUrl('nine/gray_bubble.png')})` }"
          >
            <div class="">{{ step7 || 0 }}</div>
          </div>
          <div class="step-label">第六次复习</div>
        </div>
        <div
          class="step-size step8"
          :style="{
            backgroundImage: `url(${getBrandImageUrl('nine/step8.png')})`,
          }"
          @click="onMastery(step8, 8)"
        >
          <div
            class="step-bubble"
            :style="{ backgroundImage: `url(${getBrandImageUrl('nine/blue_bubble.png')})` }"
          >
            <div class="">{{ step8 || 0 }}</div>
          </div>
          <div class="step-label">掌握单词</div>
        </div>
      </div>

      <div class="buttons flex-row justify-around">
        <ion-button class="buttons-button orange" shape="round" @click="onContinue"
          >继续练习
        </ion-button>
        <ion-button class="buttons-button linear-green" shape="round" @click="clickReviewButton"
          >开始复习
        </ion-button>
      </div>
    </div>
    <!-- </page-white-background> -->
  </div>
</template>

<script>
import { actionSheetController, IonButton, IonHeader, modalController } from "@ionic/vue"

import BeforeTest from "@/views/speed/BeforeTest"
import Review from "@/views/speed/Review"
import Sign from "@/views/speed/Sign"
import NineOld from "@/views/speed/NineOld"
import { caretDown, library } from "ionicons/icons"
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import Time30 from "@/assets/teacher_index/version5/time_30.svg"
import Time60 from "@/assets/teacher_index/version5/time_60.svg"
import TimeExperience from "@/assets/teacher_index/version5/time_exper.svg"
import maleStudent from "@/assets/teacher_index/version5/male_student.png"
import maleSex from "@/assets/teacher_index/version5/male.svg"
import femaleStudent from "@/assets/teacher_index/version5/female_student.png"
import femaleSex from "@/assets/teacher_index/version5/female.svg"
import unKnown from "@/assets/teacher_index/version5/unknown_gender.png"

export default {
  name: "SpeedReview",
  components: {
    IonHeader,
    IonButton,
  },
  props: ["studentId", "readingId"],
  setup() {
    return {
      library,
      caretDown,
    }
  },
  computed: {
    // 学生 userType=1（项目约定；userType=2 为陪练）
    isStudent() {
      return Number(this.userinfo?.userType) === 1
    },
  },
  data() {
    return {
      userinfo: {},
      courseId: undefined,
      courseName: undefined,
      reviewNum: 0,
      learnNum: 0,
      totalNum: 0,
      currentNum: 0,
      step0: 0,
      step1: 0,
      step2: 0,
      step3: 0,
      step4: 0,
      step5: 0,
      step6: 0,
      step7: 0,
      step8: 0,

      //################################
      buttons: [],
      brandImages: BRAND_IMAGES,
      studentName: "", // 学生姓名
      studentAvatar: "", // 学生头像
      classTimeType: "", // 练习类型 30分钟 | 60分钟 | 体验课
      classScope: "", // 练习时间的范围
      startTime: "",
      endTime: "",
      progressValue: 0.3,
      statusObj: {
        1: Time30,
        2: Time60,
        3: TimeExperience,
        4: "",
      },
      isTrial: false,
      genderObj: {
        // sex 性别 1 男 2 女
        1: {
          avatar: maleStudent,
          sex: maleSex,
        },
        2: {
          avatar: femaleStudent,
          sex: femaleSex,
        },
        0: {
          avatar: unKnown,
          sex: "",
        },
      },
    }
  },

  mounted() {
    this.userinfo = this.store.getUser() || {}
    this.appointment = this.store.getAppointment()
    this.isTrial = this.appointment.classification === 3
    console.log("aaa", this.appointment.courseName)
    if (this.appointment.courseId) {
      this.learningInfo()
    }
    this.queryMyCourseList()
    this.getAudioPath() //获取音频文件路径
    this.initNineStudentInfo()
  },

  methods: {
    getBrandImageUrl,
    async goToOldVersion() {
      this.onClose()
      const modal = await modalController.create({
        component: NineOld,
        componentProps: {
          studentId: this.studentId,
          readingId: this.readingId,
        },
        cssClass: "modal_controller_class",
      })
      await modal.present()
      await modal.onDidDismiss()
      this.learningInfo()
      this.queryMyCourseList()
    },
    //显示选择资料列表（学生不可切换词库）
    async showCourseSelect() {
      if (this.isStudent) return
      const actionSheet = await actionSheetController.create({
        header: "选择资料",
        cssClass: "myActionSheet",
        buttons: this.buttons,
      })
      await actionSheet.present()
    },

    learningInfo() {
      this.ajax.get("/vocabulary/learningInfo?studentId=" + this.studentId).then((res) => {
        this.courseId = res.data.courseId
        this.courseName = res.data.courseName
        this.reviewNum = res.data.reviewNum
        this.learnNum = res.data.learnNum
        this.totalNum = res.data.totalNum
        this.currentNum = res.data.currentNum
        this.step0 = res.data.step0
        this.step1 = res.data.step1
        this.step2 = res.data.step2
        this.step3 = res.data.step3
        this.step4 = res.data.step4
        this.step5 = res.data.step5
        this.step6 = res.data.step6
        this.step7 = res.data.step7
        this.step8 = res.data.step8

        this.appointment.courseName = this.courseName
        this.appointment.courseId = this.courseId
        this.store.setAppointment(this.appointment)
      })
    },

    //学新
    async openBeforeTest() {
      if (!this.courseName && this.isTrial) {
        this.alert("请选择要体验的词库")
        return
      }
      this.ajax
        .get(
          "/vocabulary/countNotInPersonal?studentId=" +
            this.studentId +
            "&courseId=" +
            this.courseId
        )
        .then(async (res) => {
          if (res.data.success) {
            if (res.data.count > 0) {
              sessionStorage.setItem("isNew", "0")
              const modal = await modalController.create({
                component: BeforeTest,
                componentProps: { studentId: this.studentId },
                cssClass: "modal_controller_class",
              })
              await modal.present()
              const { data } = await modal.onDidDismiss()
              console.log("nine1", data)
              if (data) {
                if (data.status === "TO_ARTICLE" || data.status === "TO_ARTICLE") {
                  await modalController.dismiss({ ...data })
                } else {
                  this.learningInfo()
                }
              }
            } else {
              this.alert("本词库已训完，请复习或选其他资料库训练！")
            }
          }
        })
    },

    //复习
    async openReview(mastery) {
      sessionStorage.setItem("isNew", "1")
      const modal = await modalController.create({
        component: Review,
        componentProps: { studentId: this.studentId, mastery: mastery },
        cssClass: "modal_controller_class",
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      console.log("review", data)
      if (data) {
        if (data.status === "TO_ARTICLE") {
          await modalController.dismiss({ ...data })
        } else {
          this.learningInfo()
        }
      } else {
        this.learningInfo()
      }
    },

    async openSign() {
      const modal = await modalController.create({
        component: Sign,
        componentProps: { studentId: this.studentId },
        cssClass: "modal_controller_class",
      })

      await modal.present()
      const { data } = await modal.onDidDismiss()
      if (data) {
        if (data.status === "TO_ARTICLE") {
          await modalController.dismiss({ ...data })
        }
      }
    },

    clickReviewButton() {
      if (!this.courseName && this.isTrial) {
        this.alert("请选择要体验的词库")
        return
      }
      this.openReview(0)
    },

    //继续练习
    onContinue() {
      if (!this.courseName && this.isTrial) {
        this.alert("请选择要体验的词库")
        return
      }
      if (this.currentNum > 0) {
        this.openSign()
      } else {
        this.openBeforeTest()
      }
    },

    onMastery(num, mastery) {
      if (!this.courseName && this.isTrial) {
        this.alert("请选择要体验的词库")
        return
      }
      if (num && num > 0) {
        this.openReview(mastery)
      }
    },

    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 200)
      this.dataList = []
      this.learningInfo()
      this.queryMyCourseList()
    },

    //
    queryMyCourseList() {
      const that = this
      const studentId = this.store.getStudentId()
      const appointment = this.store.getAppointment()
      let trial = true

      if (appointment != null) {
        trial = appointment.classification == 3
      }

      this.ajax
        .get("/course/queryMyCourseList?studentId=" + studentId + "&trial=" + trial)
        .then((res) => {
          if (res.data.success) {
            if (res.data.list) {
              that.buttons = []
              res.data.list.forEach((item) => {
                let strTitle = ""
                if (item.finished) {
                  strTitle = item.courseName + "   (已训完)"
                }

                //显示学新数量
                else {
                  if (item.learnNewNumber) {
                    strTitle = item.courseName + "  " + item.learnNewNumber + "/" + item.number
                  } else {
                    strTitle = item.courseName
                  }
                }

                const param = {
                  studentId: studentId,
                  courseId: item.courseId,
                  aptmId: appointment.aptmId,
                  schoolId: appointment.schoolId,
                  courseName: item.courseName,
                }

                let showButton = false

                //体验课
                if (appointment.classification == 3) {
                  showButton = true
                }

                //其它资料类型
                //如果是阅读课，则限制词库范围
                else if (
                  (appointment.courseTypeId == 3 && item.courseTypeId == 3) ||
                  (appointment.courseTypeId == 1 && item.courseTypeId == 1)
                ) {
                  showButton = true
                }

                if (showButton) {
                  that.buttons.push({
                    text: strTitle,
                    handler: () => {
                      that.ajax.post("/course/changeCourse", param).then((res1) => {
                        if (res1.data.success) {
                          that.courseName = item.courseName
                          that.learningInfo()
                        }
                      })
                    },
                  })
                }
              })
            }

            that.buttons.push({ text: "取消", role: "cancel" })
          }
        })
    },

    //获取音频文件路径
    getAudioPath() {
      this.ajax.get("/config/getConfig?key=AUDIO_INNER_PATH").then((res) => {
        if (res.data.success) {
          this.setAudioInnerPath(res.data.data)
        }
      })
    },

    initNineStudentInfo() {
      // 资料类型 3 体验课 2 60分钟 1 30分钟
      let studentInfo = this.store.getAppointment()
      if (studentInfo.aptmId == 0) {
        studentInfo = this.store.getUser()
      }
      this.studentName = studentInfo.studentName || studentInfo.username
      this.studentAvatar = studentInfo.sex ? this.genderObj[studentInfo.sex].avatar : unKnown
      console.log("studentInfo", this.studentAvatar)
      this.classTimeType = studentInfo.classification || ""
      if (studentInfo.startTime && studentInfo.endTime) {
        this.classScope = studentInfo.startTime + "-" + studentInfo.endTime
      } else {
        this.classScope = null
      }
      this.startTime = studentInfo.startTime
      this.endTime = studentInfo.endTime
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.nine-page {
  width: 100%;
  height: 100%;
  overflow: auto;
  // background: linear-gradient(180deg, #dcf8ef 0%, #f2f3f7 60%);
  // background-image: url("@/assets/newNine/nine_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;

  .navbar {
    width: 100%;
    height: 2.75rem;
    text-align: center;
    position: relative;
    font-size: 1rem;
    font-weight: 600;
    padding: 0 1rem;
    .navbar-item {
      font-size: 1.0625rem;
      font-weight: 500;
      color: #012b43;
      cursor: pointer;
      width: 33.33%;
      text-align: center;
      white-space: nowrap;
    }
    .navbar-item-right {
      text-align: right;
      text-align: end;
      font-size: 0.8rem;
    }

    .nav-icon {
      // width: 2rem;
      width: 0.375rem;
      height: 0.6875rem;
      margin-right: 0.375rem;
    }
  }
  .info-box {
    padding: 0 1rem;
  }
  .info-row {
    display: flex;
    align-items: flex-start;
    gap: 0.25rem;
  }
  .book-box {
    display: inline-flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .book-item {
    width: 4rem;
    height: 4rem;
    border-radius: 0.75rem;
    border: 0.09rem solid #fff;
    background: linear-gradient(180deg, #e2f3e9 0%, #4cbe7c 100%);
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;
  }
  .book-img {
    width: 3.875rem;
    height: 4.3125rem;
    margin-bottom: -0.5625rem;
  }
  .changeWord-btn {
    width: 5.25rem;
    height: 1.75rem;
    background: linear-gradient(180deg, #ffffff 0%, #d8d8d8 100%);
    border-radius: 1rem;
    border: 0.0625rem solid #fff;
    background: linear-gradient(180deg, #ffd93f 6.25%, #ff8825 100%);
    margin-top: -0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7rem;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
    position: relative;
    img {
      width: 0.8rem;
      height: 0.8rem;
      margin-right: 0.1rem;
    }
  }

  .course-bubble {
    width: 9.375rem;
    flex: 0 0 9.375rem;
    background: #ffffff;
    border-radius: 0.75rem;
    padding: 0.5rem;
    color: #1e2023;
    font-weight: 600;
    box-shadow: 0 0.5rem 1.25rem rgba(0, 0, 0, 0.08);
    cursor: pointer;
    user-select: none;
    position: relative;
    margin-top: 0.3rem;
  }

  .course-bubble::before {
    content: "";
    position: absolute;
    left: -0.4rem;
    top: 1.25rem;
    width: 0;
    height: 0;
    border-top: 0.5rem solid transparent;
    border-bottom: 0.5rem solid transparent;
    border-right: 0.5rem solid #ffffff;
    filter: drop-shadow(-0.1rem 0.2rem 0.25rem rgba(0, 0, 0, 0.08));
  }

  .course-bubble_text,
  .course-bubble_empty {
    font-size: 1rem;
    line-height: 1.35;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  .course-bubble_empty {
    opacity: 0.7;
    font-weight: 500;
  }
  .student-info {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    // margin-top: 1.625rem;
    position: absolute;
    top: 1.5rem;
    right: 3.5rem;
    z-index: 1;
    .student-info-item {
      display: inline-flex;
      align-items: center;
      max-width: 8rem;
      overflow: hidden;
      min-width: 0;
    }
    .student-head {
      width: 1.75rem;
      height: 1.75rem;
      border-radius: 50%;
      border: 0.0938rem solid #fff;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.56) 4.17%,
        rgba(255, 255, 255, 0.7) 95.83%
      );
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        z-index: 1;
        position: relative;
      }
    }
    .student-name {
      max-width: 8rem;
      width: auto;
      flex: 0 1 auto;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0 0.4375rem 0 1.1rem;
      border-radius: 0 2.3125rem 2.3125rem 0;
      height: 1.5rem;
      display: inline-block;
      box-sizing: border-box;
      line-height: 1.3125rem;
      color: #fff;
      font-size: 0.75rem;

      margin-left: -0.875rem;
      border-radius: 0 2.6875rem 2.6875rem 0;
      background: #ff7d03;
    }
  }
  .road-box {
    position: relative;
    // margin-bottom: 1rem;
    width: 100%;
    height: 100%;
    width: 23.4375rem;
    height: 44.375rem;
  }
  .road-img {
    width: 23.4375rem;
    height: 44.375rem;
    position: relative;
    z-index: 0;
    display: block;
    margin: auto;
  }
  .learn-word-box {
    position: absolute;
    bottom: 7.1875rem;
    right: 2.1875rem;
    width: 7.5rem;
    height: 6.5625rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    text-align: center;
    z-index: 2;
    width: 5.625rem;
    height: 8.0625rem;
  }
  .yingxiaowu-img {
    position: absolute;
    width: 5.4375rem;
    height: 6.5625rem;
    right: -0.05rem;
    bottom: 1.65rem;
    z-index: 1;
  }
  .yingxiaowu-bubble {
    position: absolute;
    right: 5.4rem;
    bottom: 4.7rem;
    width: 6.5rem;
    min-height: 2.8rem;
    padding: 0.375rem 0.5rem;
    background: #ffffff;
    border-radius: 0.75rem;
    box-shadow: 0 0.5rem 1.25rem rgba(0, 0, 0, 0.08);
    color: #ff7a00;
    font-size: 0.6875rem;
    font-weight: 500;
    line-height: 1.5;
    z-index: 3;
    user-select: none;
  }
  .yingxiaowu-bubble::after {
    content: "";
    position: absolute;
    right: -0.45rem;
    top: 0.95rem;
    width: 0;
    height: 0;
    border-top: 0.4rem solid transparent;
    border-bottom: 0.4rem solid transparent;
    border-left: 0.5rem solid #ffffff;
  }
  .learn-word-text {
    font-size: 1.125rem;
    font-weight: 600;
    color: #fff;
    margin-top: 88%;
  }
  .learn-word-text-bottom {
    font-size: 0.75rem;
    font-weight: 600;
    color: #fff;
  }
  .buttons {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 25rem;
    height: 8.0625rem;
    background: linear-gradient(180deg, rgba(230, 255, 236, 0) 0%, #e6ffec 75.81%);
    padding-top: 2.3125rem;
    &-button {
      width: 45%;
      height: 3rem;
      font-size: 1rem;
      --box-shadow: none;
    }

    .orange {
      --background: transparent;
      --border-color: var(--theme-color);
      --border-width: 0.09rem;
      --border-style: solid;
      color: var(--theme-color);
    }

    .linear-green {
      --background: var(--theme-color);
      color: #fff;
    }
  }

  .bottom-logo {
    width: 70%;
    height: 3rem;

    img {
      width: 100%;
    }
  }

  &_page {
    width: 100%;
    height: 100%;
  }

  &_card {
    box-shadow: 0 0 1px 0 var(--mark-border-color);
    padding: 4vw 3vw;

    .user-name {
      font-size: var(--font-3);
    }

    .class-type {
      height: 3.5vw;
    }

    .nine-avatar {
      width: 10vw;
      object-fit: contain;
    }

    .nine-info {
      width: 100%;
    }

    .text {
      color: var(--font-black-color);
    }

    .class-time {
      color: var(--font-deep-gray);
      padding-bottom: 3vw;
      margin-bottom: 3vw;

      img {
        margin-bottom: 0.3vh;
      }
    }

    .class-statistic {
      border-top: 1px solid var(--border-color-1);
      padding-top: 3vw;

      & > div {
        text-align: center;
        color: var(--font-deep-gray);
      }

      .num {
        font-size: var(--font-5);
        font-weight: 600;
        line-height: 2.5rem;
        color: var(--font-black-color);
      }
    }
  }

  .dashboard {
    position: relative;
    width: 90%;
    margin: 0 auto;

    &_image {
      position: relative;
      width: 100%;
      z-index: 4;
    }

    &_content {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50%;
    }

    &_button {
      position: absolute;
      left: 50%;
      bottom: 60%;
      width: 20%;
      z-index: 5;
      transform: translate(-50%, -50%);
    }

    &_block {
      width: 100%;
      height: 100%;

      .white-block {
        position: absolute;
        left: 0;
        bottom: 7%;
        width: 100%;
        z-index: 5;
      }

      .pointer {
        position: absolute;
        left: 0;
        top: -98%;
        width: 100%;
        transform: rotate(24deg);
        z-index: 3;
      }

      .line {
        position: absolute;
        left: 0;
        bottom: 73%;
        width: 100%;
        z-index: 6;
      }

      .block-left {
        position: absolute;
        left: 2%;
        bottom: 85%;
        width: 20%;
        z-index: 4;
      }

      .block-right {
        position: absolute;
        right: 2%;
        bottom: 85%;
        width: 20%;
        z-index: 4;
      }

      .button {
        position: absolute;
        left: 12%;
        bottom: 48%;
        width: 50%;
        z-index: 7;
        white-space: nowrap;
        //font-weight: 600;

        img {
          width: 20%;
          margin-left: 5%;
        }
      }

      .continue-button {
        left: 12%;
      }

      .start-button {
        left: 69%;
      }
    }
  }
}

.nine-tips {
  margin-top: 1rem;
  text-align: center;

  &_top {
    color: #125543;
    font-size: 1.2rem;
    margin-bottom: 0.2rem;
  }

  &_bottom {
    color: #999999;
    font-size: 0.9rem;
  }
}
.content-box {
  // padding-bottom: 1rem;
  width: 100%;
  height: 44.375rem;
  position: relative;
}
.step-size {
  width: 6rem;
  height: 6rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.step1 {
  position: absolute;
  // width: 7.2813rem;
  // height: 7.0938rem;
  right: 8.5188rem;
  bottom: 6.9rem;
}
.text1 {
  color: #e95525;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  margin-top: 1.8rem;
  padding-left: 0.5rem;
}
.step2 {
  position: absolute;
  // width: 5.2813rem;
  // height: 5.8125rem;
  left: 2.2875rem;
  bottom: 8.525rem;
}
.step-text {
  text-align: center;
  font-size: 1.125rem;
  font-weight: 700;
  margin-top: 1.5rem;
}
.text2 {
  color: #d33400;
}
.step3 {
  position: absolute;
  // width: 5.2813rem;
  // height: 5.8125rem;
  right: 2.975rem;
  bottom: 14.6rem;
}
.text3 {
  color: #fc4003;
}
.step4 {
  position: absolute;
  // width: 5.2813rem;
  // height: 5.8125rem;
  left: 8.9688rem;
  bottom: 17.475rem;
}
.text4 {
  color: #e95525;
}
.step5 {
  position: absolute;
  // width: 5.2813rem;
  // height: 5.8125rem;
  left: 2.9rem;
  bottom: 19.1875rem;
}
.text5 {
  color: #de7600;
}
.step6 {
  position: absolute;
  // width: 5.2813rem;
  // height: 5.8125rem;
  right: 4rem;
  bottom: 24.1125rem;
}
.text6 {
  color: #67b000;
}
.step7 {
  position: absolute;
  // width: 5.2813rem;
  // height: 5.8125rem;
  left: 4.2875rem;
  bottom: 28.5rem;
}
.text7 {
  color: #1ca36d;
}
.step8 {
  position: absolute;
  // width: 9.75rem;
  // height: 12.25rem;
  right: 5.025rem;
  bottom: 32.125rem;
}
.text8 {
  color: #04863b;
  margin-top: 5.1rem;
  padding-left: 1rem;
}
.word-option-box {
  width: 100%;
  min-height: 2.5rem;
  padding: 0.3125rem 0.9375rem;
  border-radius: 0.625rem;
  border: 1px solid #fff;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: space-between;

  &--disabled {
    pointer-events: none;
    justify-content: center;
  }
}
.course-name_empty {
  color: #9a9b9c;
  font-size: 0.875rem;
  flex: 1;
}
.course-name_text {
  font-size: 0.875rem;
  flex: 1;
}
.bottom-icon {
  width: 1.25rem;
  height: 1.25rem;
}
.nine-bg-top {
  width: 100%;
  height: 100px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.step-bubble {
  width: 3.3125rem;
  height: 2.875rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  padding-top: 0.825rem;
  text-align: center;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #fff;
  margin: -0.7rem auto 0;
}
.step-label {
  white-space: nowrap;
  height: 1.375rem;
  padding: 0 0.5625rem;
  border-radius: 0.6875rem;
  border: 1px solid #fff;
  background: #5f708a;
  font-size: 0.6875rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  // margin: 0.8438rem auto 0;
  position: absolute;
  bottom: 0.7125rem;
  left: 50%;
  transform: translateX(-50%);
}
</style>
